<template>
    <div class="professional-image-upload" :class="{ 'professional-image-upload--makeup': tone === 'makeup' }">
        <div class="professional-image-upload__heading">
            <span>{{ label }} <b v-if="required">*</b></span>
            <strong>{{ files.length }}/{{ maxCount }} 张</strong>
        </div>
        <div class="professional-image-upload__grid">
            <div v-for="(file, index) in files" :key="`${file.name}-${index}`" class="professional-image-upload__tile professional-image-upload__tile--preview">
                <img :src="previewUrls[index]" :alt="`${label} ${index + 1}`" />
                <span class="professional-image-upload__counter">{{ index + 1 }}/{{ maxCount }}</span>
                <button
                    type="button"
                    class="professional-image-upload__remove"
                    :aria-label="`删除${label} ${index + 1}`"
                    title="删除图片"
                    @click.stop.prevent="$emit('remove', index)">
                    <i class="el-icon-close" aria-hidden="true"></i>
                </button>
            </div>
            <label v-if="files.length < maxCount" class="professional-image-upload__tile professional-image-upload__tile--add">
                <input type="file" :accept="accept" @change="$emit('select', $event)" />
                <span class="professional-image-upload__add-content">
                    <i aria-hidden="true">+</i>
                    <strong>{{ files.length }}/{{ maxCount }}</strong>
                </span>
            </label>
        </div>
        <small class="professional-image-upload__hint">{{ hint }}</small>
    </div>
</template>

<script>
export default {
    name: "ProfessionalApplicationImageUpload",
    props: {
        label: { type: String, required: true },
        accept: { type: String, required: true },
        files: { type: Array, default: () => [] },
        previewUrls: { type: Array, default: () => [] },
        hint: { type: String, default: "支持 JPG / PNG，单张最大 5 MiB；可逐张上传。" },
        maxCount: { type: Number, default: 1 },
        tone: { type: String, default: "photographer" },
        required: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.professional-image-upload { display: grid; gap: 8px; color: #5e5763; }
.professional-image-upload__heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 11px; font-weight: 800; }
.professional-image-upload__heading b { color: #dc657f; }
.professional-image-upload__heading strong { color: #ad7a36; font-size: 10px; }
.professional-image-upload__heading strong::first-letter { color: inherit; }
.professional-image-upload__grid { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 8px; }
.professional-image-upload__tile { position: relative; display: grid; min-width: 0; aspect-ratio: 1; overflow: hidden; border-radius: 9px; }
.professional-image-upload__tile--preview { background: #edf6fa; border: 1px solid #d1e4eb; }
.professional-image-upload__tile--preview img { display: block; width: 100%; height: 100%; object-fit: cover; }
.professional-image-upload__tile--add { place-items: center; color: #4a809e; background: #fbfdfe; border: 1px dashed #a9cfdf; cursor: pointer; }
.professional-image-upload__tile--add:hover { background: #f0f8fc; border-color: #6fa9c3; }
.professional-image-upload__tile--add input { display: none; }
.professional-image-upload__add-content { display: grid; justify-items: center; gap: 4px; }
.professional-image-upload__add-content i { display: grid; width: 30px; height: 30px; place-items: center; color: #4f90ae; background: #fff; border: 1px solid #bad8e6; border-radius: 8px; font-size: 22px; font-style: normal; font-weight: 400; line-height: 1; }
.professional-image-upload__add-content strong { color: #4a809e; font-size: 10px; }
.professional-image-upload__counter { position: absolute; right: 4px; bottom: 4px; padding: 2px 4px; color: #fff; background: rgba(40, 51, 59, .7); border-radius: 4px; font-size: 9px; line-height: 1.2; }
.professional-image-upload__remove { position: absolute; top: 4px; right: 4px; display: grid; width: 22px; height: 22px; place-items: center; padding: 0; color: #fff; background: rgba(73, 48, 61, .76); border: 0; border-radius: 50%; cursor: pointer; font-size: 13px; }
.professional-image-upload__remove:hover { background: #d56886; }
.professional-image-upload__remove:focus-visible { outline: 2px solid #fff; outline-offset: 1px; }
.professional-image-upload__hint { color: #857f76; font-size: 10px; font-weight: 400; line-height: 1.5; }
.professional-image-upload--makeup .professional-image-upload__tile--preview { background: #fff1f4; border-color: #f0d0d8; }
.professional-image-upload--makeup .professional-image-upload__tile--add { color: #b3536e; background: #fffafb; border-color: #e4aab9; }
.professional-image-upload--makeup .professional-image-upload__tile--add:hover { background: #fff0f4; border-color: #d9849b; }
.professional-image-upload--makeup .professional-image-upload__add-content i { color: #c55d78; border-color: #edbdc9; }
.professional-image-upload--makeup .professional-image-upload__add-content strong { color: #b3536e; }
.professional-image-upload--makeup .professional-image-upload__remove:hover { background: #d56886; }
@media (max-width: 600px) { .professional-image-upload__grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
</style>
